'use client';

import { Slide } from 'react-toastify';

import { CustomToastContainer } from './Toast.styles';

export const ToastContainer = () => (
    <CustomToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        closeButton={false}
        rtl={false}
        pauseOnFocusLoss={true}
        pauseOnHover={true}
        transition={Slide}
        draggable={false}
    />
);
